import Site from './Site.i18n';

export default Site
export { Site as Base }